module.exports = __webpack_public_path__ + "static/004.thumb-895ea230c5abbcfaa326514bf1b82667.jpg";